import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { TransactionTableSkeletonLoader } from "@features/account-statement/desktop/components/TransactionTableSkeletonLoader";
import AccountStatementTransactionItem from "@features/account-statement/desktop/table/AccountStatementTableTransaction";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";

import AccountStatementPager from "../components/AccountStatementPager";
import { AccountStatementPopupDetails } from "../details";

export default observer(function AccountStatementTransactionTable() {
	const t = useTranslation().t;
	const store = useAccountStatementStore();

	if (store.transactionTableLoader.isLoading) {
		return <TransactionTableSkeletonLoader />;
	}
	if (store.tableData === null) {
		return null;
	}

	const { totalRecords, transactions, page, recordsPerPage } =
		store.tableData;

	if (!transactions || transactions.length == 0) {
		return (
			<InfoMessageComponent
				type="note"
				message={t<string>("ACC_STATEMENT.TABLES.NO_TRANSACTION_TXT")}
				addClassName="u-mar--top--xsml"
			/>
		);
	}

	return (
		<>
			<div id="scroll-div"></div>

			<table className="table table--shadowy u-mar--top--xsml">
				<thead className="table__head">
					<tr className="table__head__row table__row">
						<th className="table__head__cell table__cell">ID</th>
						<th className="table__head__cell table__cell">
							{t<string>("ACC_STATEMENT.TABLES.TABLE_DATE")}
						</th>
						<th className="table__head__cell table__cell">
							{t<string>("ACC_STATEMENT.TABLES.TABLE_TYPE")}
						</th>
						<th className="table__head__cell table__cell u-type--right">
							{t("ACC_STATEMENT.TABLES.TABLE_AMOUNT")}
						</th>
						<th className="table__head__cell table__cell u-type--right">
							{t("ACC_STATEMENT.TABLES.TABLE_BAL")}
						</th>
						<th className="table__head__cell table__cell u-type--right">
							<span className="counter counter--base counter--dark--outlined">
								{totalRecords}
							</span>
						</th>
					</tr>
				</thead>
				<tbody className="table__body">
					{transactions.map((transaction) => (
						<AccountStatementTransactionItem
							key={transaction.numericalId}
							transaction={transaction}
						/>
					))}
				</tbody>
			</table>

			<AccountStatementPopupDetails />

			<AccountStatementPager
				pageNumber={page}
				pageSize={recordsPerPage}
				totalItems={totalRecords}
				onPageChange={store.changePage}
				isRemoveAllVisible={false}
				className="u-padd--x--reset"
			/>
		</>
	);
});
